import { ChartType } from './tradingViewSimpleChart.props.js';
import { getLang } from '../../utils/langs.utils.js';

const chartDataToSeries = (data, type) => {
    return data.map((e) => {
        return type === ChartType.candlesticks
            ? { time: e.time, open: e.open, high: e.high, low: e.low, close: e.close }
            : {
                time: e.time,
                value: type === ChartType.histogram ? e.volume : e.close,
            };
    });
};
const fmtPrice = (price, precision = 2) => {
    return (Math.round(price * 100) / 100).toFixed(precision);
};
const getCandlesticksTooltip = (price, translations) => {
    return `<div>${translations.open}:
    ${fmtPrice(price.open)}
    </div>
    <div>${translations.close}:
    ${fmtPrice(price.close)}
    </div>
    <div>${translations.high}:
    ${fmtPrice(price.high)}
    </div>
    <div>${translations.low}:
    ${fmtPrice(price.low)}
    </div>`;
};
const formateHasIntraDay = (time, hasIntraDay, ticker) => {
    const date = new Date(time * 1000);
    const locale = getLang();
    if (hasIntraDay && ticker) {
        return date.toLocaleTimeString(locale, {
            hour: 'numeric',
            minute: 'numeric',
            hour12: false,
        });
    }
    else if (hasIntraDay) {
        return date.toLocaleTimeString(locale, {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false,
        });
    }
    return date.toLocaleDateString(locale, {
        year: '2-digit',
        month: 'short',
        day: 'numeric',
    });
};
function formatUnixDate(time, isIntraDay = false, locale = getLang()) {
    const date = new Date(time * 1000);
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    const optionsIntraDay = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
    };
    return isIntraDay
        ? date.toLocaleTimeString(locale, optionsIntraDay)
        : date.toLocaleDateString(locale, options);
}

export { chartDataToSeries, fmtPrice, formatUnixDate, formateHasIntraDay, getCandlesticksTooltip };
//# sourceMappingURL=tradingViewSimpleChart.utils.js.map
